<template>
    <modal :show="show" showLarge>
        <div slot="modalHeader">
          <modal-header :closeModal="customClose">{{ (creativeUnitType=="after-effects") ? "Footage Library" : "Asset Library"}}</modal-header>
        </div>
        <spinner-icon v-if="loading" />
        <notifications :messages="notifications" v-if="showAssetNotification && notifications && notifications.length > 0"/>
        <div style="display:flex; justify-content: space-between;" class="assetUpload">
          <div>
            <label>Upload additional project assets</label>
            <br>
            <label><small>Upload a zip file of assets or individual assets. (Max file size 2GB. You can upload additional assets later)</small></label>
            <upload-file icon="upload" ctaText="Upload New Asset" @input="onUploadAsset" multipleFiles />
          </div>
          <div v-if="creativeUnitType=='after-effects' && isAEP" style="margin-top: 10px !important;">
            <label style="font-weight:normal;">
              <small>
<!--                You have selected <b>{{ footageStructure}}</b> as your footage folder name-->
<!--                <br>-->
<!--                <div class="text-right">Issues with footage not loading in your renders?</div>-->
                <div v-if="isEditing">Adobe After Effect footage folder name:</div>
            </small>
            </label>
            <br>
            <div class="text-right">
              <dropdown v-if="isEditing" :options="footageOptions()" @click.prevent="onCancel" v-model="footageStructure" :current="footageStructure" id="textfield1" style="margin-bottom: 5px;"/>
              <button-cta :is-disabled="isEditing ? disabled:false" class="btn btn-primary" :onClick="editFootage">{{ isEditing ? "Save " : "Edit"}} Footage Settings</button-cta>
              <button-cta v-if="!isEditing" class="btn btn-danger"  :title="'Delete Footage'" data-modalType="deleteFootage" :data-modalID="1"
                      :onClick="onLaunchModal"><i class="fa fa-trash"></i></button-cta>
              <modal-delete-footage :show="showModal.deleteFootage" :type="modalType" :confirmId="modalId" @close="toggleModal('deleteFootage')" @confirmDeleteUnit="delFootage"/>
<!--              <button-cta  class="btn btn-secondary"  :closeModal="customClose">{{ isEditing ? "Cancel " : "Edit"}} </button-cta>-->
              <button v-if="isEditing" @click.prevent="isEditing = !isEditing" class="btn btn-secondary">
                {{ isEditing ? "Cancel " : "Edit"}}
              </button>
            </div>
          </div>
        </div>
        <hr />
        <search-box v-model="search" name="assets..." ref="searchBox" />
        <hr />
        <asset-table :tableData="filteredAssets" @deleteFile="onDeleteAsset" @selectFile="selectImage" v-bind:confirmId="confirmId" :type="creativeUnitType"/>
        <div slot="modalFooter">
          <modal-footer cancelText="Close" :closeModal="customClose" hideConfirmText />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import CreativeTable from '@/components/CreativeTable/creative-table'
import AssetTable from '@/components/AssetTable/asset-table'
import UploadFile from '@/components/UploadFile/upload-file'
import SearchBox from '@/components/SearchBox/searchbox'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import Notifications from '@/components/Notifications/notifications'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import ModalDeleteFootage from '@/components/Modal/footage/modal-delete-footage'

import {modalMixin} from '@/mixins/modalMixin'
import {assetMixin} from '@/mixins/assetMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_asset_library',
  mixins: [modalMixin, assetMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalDeleteFootage,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field,
    CreativeTable,
    AssetTable,
    UploadFile,
    SearchBox,
    SpinnerIcon,
    Notifications,
    Dropdown
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String,
    fieldType: String,
    forceReloadAssetsLibraryData: {type: Boolean, default: false},
    creativeUnitType: {
      type: String,
      default: ''
    },
    footageStructure: {
      type: String,
      default: ''
    },
    masters: Array
  },
  data: () => ({
    errors: {
      name: ''
    },
    search: '',
    showAssetNotification: false,
    dataLoaded: '',
    isEditing: false,
    disabled: true
  }),
  created () {
    if (this.creativeUnits.data) {
      this.footageStructure = this.creativeUnits.data.footageFolder
    }
  },
  computed: {
    assetId () {
      return this.$route.params.id
    },
    isEditMode () {
      return this.confirmId
    },
    filteredAssets () {
      return this.assets.filter(asset => {
        return asset.file.toLowerCase().includes(this.search.toLowerCase()) || asset.width.toLowerCase().includes(this.search.toLowerCase()) || asset.height.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    isAEP () {
      if (this.creativeUnitType === 'after-effects' && this.masters && this.masters[0]) {
        const ext = this.masters[0].name.split('.').pop()
        if (ext === 'aep') return true
        return false
      }
    }
  },
  watch: {
    footageStructure: () => {
      if (this.footageStructure === null || this.footageStructure === '') {
        return '(Footage)'
      }
      return this.footageStructure
    },
    show: 'callAssets',
    /**
     * When the parent component triggers a change for the prop {forceReloadAssetsLibraryData}, force the value for
     * dataLoaded to empty string to force the modal to reload the assets library due an update or change.
     */
    forceReloadAssetsLibraryData: function () {
      this.dataLoaded = ''
    }
  },
  methods: {
    onCancel () {
      console.log('CANCEL SUBMIT')
      this.show = false
      this.$router.push({ name: 'users' })
    },
    cancelRow (e) {
      console.log('Child cancel row.')
      this.$emit('onCancelRow', e)
    },
    onClick: function (event) {
      this.$refs.dropdownObj.ej2Instances.value = null
      this.$refs.dropdownObj.dataBind()
    },
    closeVideos () {
      // var video = document.getElementById("myVideoPlayer");
      var elems = document.body.getElementsByTagName('video')
      // elems.forEach(this.closeVideo())
      for (let item of elems) {
        item.pause()
      }
    },
    customClose () {
      this.$refs.searchBox.clearSearch()
      this.closeVideos()
      this.close()
    },
    callAssets () {
      if (this.show) {
        if ((typeof this.fieldType === 'undefined') && this.dataLoaded === 'all') {
          return
        }
        if (this.dataLoaded === 'video' && this.fieldType === 'video') {
          return
        }
        if (this.dataLoaded === 'image' && this.fieldType === 'image') {
          return
        }
        this.startLoading()
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading Video asset box')
              this.finishLoading()
              this.dataLoaded = 'video'
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              console.log('Loading Image asset box')
              this.finishLoading()
              this.dataLoaded = 'image'
            }, error => {
              console.log(error)
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              // could remove spinner if we had one in this section
              this.finishLoading()
              this.dataLoaded = 'all'
            })
            break
        }
      }
    },
    selectImage (image) {
      this.$emit('selectImage', this.confirmId, this.field, image, this.fieldType)
      this.customClose()
    },
    onDeleteAsset (filename) {
      this.startLoading()
      const data = {
        id: this.assetId,
        fileName: filename
      }
      this.deleteAsset(data).then((response) => {
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'video'
              this.addNotification('success', response.reason)
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'image'
              this.addNotification('success', response.reason)
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'all'
              this.addNotification('success', response.reason)
            })
            break
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    onUploadAsset (e) {
      this.startLoading()
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      Object.keys(files).forEach((key) => {
        formData.append('file' + key, files[key])
      })
      const data = {
        id: this.assetId,
        file: formData
      }
      this.uploadAssets(data).then((response) => {
        switch (this.fieldType) {
          case 'video':
            this.getVideoAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'video'
              this.addNotification('success', response.status)
            })
            break
          case 'image':
            this.getImageAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'image'
              this.addNotification('success', response.status)
            })
            break
          default:
            this.getAssets(this.assetId).then(() => {
              this.finishLoading()
              this.showAssetNotification = true
              this.dataLoaded = 'all'
              this.addNotification('success', response.status)
            })
            this.finishLoading()
            this.showAssetNotification = true
            this.dataLoaded = 'all'
            this.addNotification('success', response.status)
            break
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    footageOptions () {
      if (this.footageStructure === this.creativeUnits.data.footageFolder) {
        this.disabled = true
      } else {
        this.disabled = false
      }
      const optionsArray = []
      let data = [
        'footage',
        '(Footage)',
        '_footage',
        'Footage'
      ]

      data.forEach((d) => {
        const option = {
          name: d,
          value: d
        }
        optionsArray.push(option)
      })
      return optionsArray
    },
    editFootage () {
      this.isEditing = !this.isEditing
      if (!this.isEditing) {
        this.startLoading()
        const formData = new FormData()
        formData.append('footage', this.footageStructure)
        formData.append('isEditing', true)
        const data = {
          id: this.assetId,
          file: formData
        }
        this.uploadFootage(data).then((response) => {
          const id = this.$route.params.id
          this.getCreativeUnits(id).then(() => {
            this.isEditing = false
            this.finishLoading()
            this.showAssetNotification = true
            this.dataLoaded = 'video'
            this.addNotification('success', response.status)
          })
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }
    },
    delFootage () {
      this.startLoading()
      const data = {
        id: this.assetId
      }
      this.deleteFootage(data).then((response) => {
        const id = this.$route.params.id
        this.getCreativeUnits(id).then(() => {
          this.isEditing = false
          this.finishLoading()
          this.showAssetNotification = true
          this.dataLoaded = 'video'
          this.addNotification('success', response.reason)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.customClose()
    }
  }
}

// eslint-disable-next-line no-unused-vars
function clearText () {
  document.getElementById('textfield1').value = ''
  document.getElementById('textfield2').value = ''
}

</script>

<style lang="scss">
  .asset {
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    border-radius: 3px;
    border: solid #e1e1e1 1px;

    .asset__img {
      background-color: #ccc;
      background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
      background-size: 10px 10px;
      background-position: 0 0, 5px 5px;
      padding: 5px;
      height: 170px;
      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
      position: relative;
      overflow: hidden;
    }

    .asset__trash {
      position: absolute;
      top: 10px;
      right: 4px;
      background-color: #2c3247;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .fa {
        font-size: 20px;
        color: #DDD;
      }
    }

    .asset__video {
      position: absolute;
      top: 10px;
      left: 4px;
      background-color: #2c3247;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .fa {
        font-size: 20px;
        color: #DDD;
      }
    }

    .asset__info {
      padding: 5px;
      text-align: center;
    }

    .asset__info_table {
      display: table;
      width: 100%;
      height: 100%;

      span {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/assets/modal-asset-library.vue